/**
 * Meta WhatsApp Cloud API media size limits (aligned with TemplateParser.vue).
 * @see https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media
 */
export const WHATSAPP_CAMPAIGN_MEDIA_MAX_BYTES = {
  Image: 5 * 1024 * 1024,
  Video: 16 * 1024 * 1024,
  Document: 100 * 1024 * 1024,
};

export function validateCampaignMediaFileSize(mediaType, file) {
  const maxBytes = WHATSAPP_CAMPAIGN_MEDIA_MAX_BYTES[mediaType];
  if (!maxBytes || !file) return { ok: true };
  if (file.size > maxBytes) return { ok: false, maxBytes };
  return { ok: true };
}

export function campaignMediaMaxSizeLabelMb(mediaType) {
  const maxBytes = WHATSAPP_CAMPAIGN_MEDIA_MAX_BYTES[mediaType];
  if (!maxBytes) return '';
  return String(Math.round(maxBytes / (1024 * 1024)));
}

/**
 * Splits template mappings into per-recipient references (params) vs fixed values (static_params).
 */
export function buildCampaignOutboundParams(campaign) {
  const sourceTypes = campaign.paramSourceTypes || {
    body: {},
    header: {},
    media: {},
    buttons: {},
  };

  const params = {
    body_params: {},
    header_params: {},
    media_params: {},
    button_params: {},
  };
  const static_params = {
    body_params: {},
    header_params: {},
    media_params: {},
    button_params: {},
  };

  (campaign.templateVars || []).forEach(obj => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    if (sourceTypes.body[key] === 'static') {
      static_params.body_params[key] = value;
    } else {
      params.body_params[key] = value;
    }
  });

  (campaign.templateHeaderVars || []).forEach(obj => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    if (sourceTypes.header[key] === 'static') {
      static_params.header_params[key] = value;
    } else {
      params.header_params[key] = value;
    }
  });

  (campaign.templateButtonsVars || []).forEach(obj => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    if (sourceTypes.buttons[key] === 'static') {
      static_params.button_params[key] = value;
    } else {
      params.button_params[key] = value;
    }
  });

  if (campaign.templateMediaImage) {
    const value = campaign.templateMediaImage.field;
    if (sourceTypes.media.Image === 'file') {
      static_params.media_params['1'] = value;
    } else {
      params.media_params['1'] = value;
    }
  } else if (campaign.templateMediaVideo) {
    const value = campaign.templateMediaVideo.field;
    if (sourceTypes.media.Video === 'file') {
      static_params.media_params['1'] = value;
    } else {
      params.media_params['1'] = value;
    }
  } else if (campaign.templateMediaDocument) {
    const value = campaign.templateMediaDocument.field;
    if (sourceTypes.media.Document === 'file') {
      static_params.media_params['1'] = value;
    } else {
      params.media_params['1'] = value;
    }
  }

  return { params, static_params };
}
